import { Phone, PhoneOff, Loader2 } from 'lucide-react'

interface VoiceChatButtonProps {
  isActive: boolean
  isListening: boolean
  isSpeaking: boolean
  isTranscribing: boolean
  onToggle: () => void
  iconSize?: number
}

export function VoiceChatButton({
  isActive,
  isListening,
  isSpeaking,
  isTranscribing,
  onToggle,
  iconSize = 15,
}: VoiceChatButtonProps) {
  const baseClass =
    'inline-flex items-center justify-center rounded-xl transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-white/30 p-2 max-sm:p-2.5'

  let stateClass: string
  let title: string

  if (!isActive) {
    stateClass = 'text-[#888888] hover:text-[#EEEEEE] hover:bg-white/5'
    title = 'Start voice chat'
  } else if (isTranscribing) {
    stateClass = 'text-amber-400'
    title = 'Transcribing...'
  } else if (isSpeaking) {
    stateClass = 'text-blue-400 animate-pulse'
    title = 'Speaking... (click to stop)'
  } else if (isListening) {
    stateClass = 'text-green-400 animate-pulse'
    title = 'Listening... (click to stop)'
  } else {
    stateClass = 'text-green-400'
    title = 'Voice chat active (click to stop)'
  }

  return (
    <button
      type="button"
      onClick={onToggle}
      className={`${baseClass} ${stateClass}`}
      title={title}
      aria-label={title}
    >
      {isTranscribing ? (
        <Loader2 size={iconSize} className="animate-spin" />
      ) : isActive ? (
        <PhoneOff size={iconSize} />
      ) : (
        <Phone size={iconSize} />
      )}
    </button>
  )
}
